import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Articles from "./Articles";
import Preview from "./Preview";
import Category from "./Category";
import Subcategory from "./Subcategory";
import Header from "./Header";
import './App.css';
import PageComponent from "./PageComponent";

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/articles" element={<Articles />} />
        <Route path="/category" element={<Category />} />
        <Route path="/subcategory" element={<Subcategory />} />

         <Route path="/:categoryName/:subCategoryName" element={<Subcategory />} />
         <Route path="/article/:article" element={<Articles />} />
         <Route path="/preview/:article" element={<Preview />} />
          <Route path="/page/:slug" element={<PageComponent />} />
      </Routes>
    </Router>
  );
}

export default App;
